import React from "react";
import VideoCarousel from "../VideoPlaylist/VideoCarousel.js";

const LayoutVideoCarousel = (props) => {

    if (!props.playlistBody || !props.playlistTitle || !props.listOfVideos) {
        return null;
    }

    return (
        <>
            <div className="ou-video-playlist-banner-description" dangerouslySetInnerHTML={{ __html: props.playlistBody.value }} />

            <VideoCarousel
                listOfVideos={props.listOfVideos}
                playlistTitle={props.playlistTitle.value}
                overlayID={props.overlayID}
            />
        </>
    )
}

export default LayoutVideoCarousel;




